<template>
  <div class="wp2CancelReservations CommonContentSingle-gray">
    <el-dialog :title="$t('original.languages271')" :visible.sync="dialogTableVisible" width="520px" append-to-body  @close="clearAddInformation()">
      <el-form ref="form" :model="form" label-width="80px">
        <table class="wp2CancelReservations" style="width: 100%">
          <tr>
            <td class="td_left">{{ $t('original.languages185') }} ：</td>
            <td class="td_right">{{ addInformation.RealName }}</td>
          </tr>
          <tr>
            <td class="td_left">{{ $t('original.languages207') }}：</td>
            <td class="td_right">
              <el-select style="width: 300px" filterable @change="selectVsitorName()" v-model="addInformation.AppointmentID" :placeholder="$t('original.languages3')">
                <el-option v-for="item in VsitorNameList" :key="item.AppointmentID" :label="item.UserID" :value="item.AppointmentID">
                </el-option>
              </el-select>
            </td>
          </tr>

          <tr v-if="addInformationShow">
            <td class="td_left">{{ $t('original.languages208') }}：</td>
            <td class="td_right">{{ addInformation.ConsultTheme }}</td>
          </tr>

          <tr v-if="addInformationShow">
            <td class="td_left">{{ $t('original.languages209') }}</td>
            <td class="td_right">{{ addInformation.ConsultCntIntroduce }}</td>
          </tr>

          <tr v-if="addInformationShow">
            <td class="td_left">{{ $t('original.languages210') }}：</td>
            <td class="td_right">{{ addInformation.AppointmentTime }}</td>
          </tr>

          <tr v-if="addInformationShow">
            <td class="td_left">{{ $t('original.languages226') }}：</td>
            <td class="td_lefttd_right">{{ addInformation.ConAddressName }}</td>
          </tr>

          <tr v-if="addInformationShow">
            <td class="td_left">{{ $t('original.languages212') }}：</td>
            <td class="td_right">{{ addInformation.ConsultType }}</td>
          </tr>

          <tr v-if="addInformationShow">
            <td class="td_left">是否删除排班：</td>
            <td class="td_lefttd_right">
              <el-radio v-model="radios" label="1">是</el-radio>
              <el-radio v-model="radios" label="0">否</el-radio>
            </td>
          </tr>

          <tr v-if="addInformationShow">
            <td class="td_left">{{ $t('original.languages216') }}：</td>
            <td class="td_right">
              <el-input type="textarea" v-model="addInformation.CancelCause" resize="none"></el-input>
            </td>
          </tr>

          <tr>
            <td colspan="2">
              <div class="buttons" style="width: 100%">
                <el-button type="primary" :loading="iscontinuous" @click="CancelReservation()">{{ $t('original.languages266') }}</el-button>

                <el-button type="primary" @click="dialogTableVisible = false">{{ $t('original.cancel') }}</el-button>
              </div>
            </td>
          </tr>
        </table>
      </el-form>
    </el-dialog>

    <el-dialog title="详情" :visible.sync="dialoginfoVisible" width="520px" append-to-body @close="clearAddInformation()">
      <el-form ref="form" label-width="80px">
        <table class="wp2CancelReservations" style="width: 100%;border-radius: 4px;padding: 0px 10px;">

          <tr>
            <td class="td_left">{{ $t('original.languages185') }}：</td>
            <td class="td_right">{{ addInformation.RealName }}</td>
          </tr>

          <tr>
            <td class="td_left">{{ $t('original.languages207') }}：</td>
            <td class="td_right">
              {{ AppointmentInfo.RealName + '(' + AppointmentInfo.UserID + ')' +  AppointmentInfo.AppointmentTime }}
            </td>
          </tr>

          <tr>
            <td class="td_left">{{ $t('original.languages208') }}：</td>
            <td class="td_right">{{ AppointmentInfo.ConsultTheme }}</td>
          </tr>

          <tr>
            <td class="td_left">{{ $t('original.languages209') }}:</td>
            <td class="td_right">{{ AppointmentInfo.ConsultCntIntroduce }}</td>
          </tr>

          <tr>
            <td class="td_left">{{ $t('original.languages226') }}:</td>
            <td class="td_lefttd_right">
              {{ AppointmentInfo.DeptName }}
            </td>
          </tr>

          <tr>
            <td class="td_left">{{ $t('original.languages212') }}：</td>
            <td class="td_right">{{ AppointmentInfo.ConsultType }}</td>
          </tr>

          <tr>
            <td class="td_left">{{ $t('original.languages216') }}：</td>
            <td class="td_right">
              {{ AppointmentInfo.CancelCause }}
            </td>
          </tr>

        </table>

        <table class="wp2CancelReservations" style="width: 100%;border-radius: 4px;padding: 0px 10px;">
          <tr>
            <td class="td_left" style="width: 75px;">
               {{ $t('original.languages190') }}:
            </td>
            
            <td class="td_right" :style="AppointmentInfo.CancelApproval == 1 ? 'color: rgba(29, 154, 255, 1);' : AppointmentInfo.CancelApproval == 2 ? 'color: rgba(21, 191, 109, 1);' : AppointmentInfo.CancelApproval == 4 ? 'color: rgba(141, 141, 141, 1);' : 'color: rgba(242, 75, 78, 1);'">
              {{ AppointmentInfo.CancelApproval == 1 ? $t('original.languages252') : AppointmentInfo.CancelApproval == 2 ? $t('original.languages203') : AppointmentInfo.CancelApproval == 4 ? $t('original.languages205') : $t('original.languages204') }}
            </td>
          </tr>

          <tr v-if="AppointmentInfo.CancelApproval == 2">
            <td class="td_left"> {{ $t('original.note') }}</td>
            <td class="td_right">
              {{ AppointmentInfo.CancelPostil }}
            </td>
          </tr>

          <tr v-if="AppointmentInfo.CancelApproval == 3">
            <td class="td_left"> {{ $t('original.languages191') }}</td>
            <td class="td_right">
              {{ AppointmentInfo.CancelPostil }}
            </td>
          </tr>

          <tr v-if="AppointmentInfo.CancelApproval != 1 && AppointmentInfo.CancelApproval != 4">
            <td class="td_left"> {{ $t('original.languages192') }}</td>
            <td class="td_right">
              {{ AppointmentInfo.CancelUser }}
            </td>
          </tr>

          <tr v-if="AppointmentInfo.CancelApproval != 1 && AppointmentInfo.CancelApproval != 4">
            <td class="td_left">{{ $t('original.languages193') }}</td>
            <td class="td_right">
              {{ AppointmentInfo.CancelTime }}
            </td>
          </tr>

          <tr v-if="AppointmentInfo.CancelApproval == 1">
            <td colspan="2">
              <div class="buttons" style="width: 100%; text-align: right">
                <el-button @click="dialoginfoVisible = false">{{ $t('original.cancel') }}</el-button>
                <el-button style="margin-right: 20px" type="primary" @click="evocation(AppointmentInfo.AppointmentID)" :loading="evocationload"> {{ $t('original.languages253') }}</el-button>
              </div>
            </td>
          </tr>

        </table>
      </el-form>
    </el-dialog>

    <el-container>
      <el-header  style="background: rgba(255, 255, 255, 1);max-height: 206px;min-height: 100px;height: auto;">
        <el-form ref="form" :model="form" label-width="80px" style="margin: 20px 0px;background: rgba(255, 255, 255, 1);padding: 10px;overflow: hidden;height: 42px;">
          <el-row style="float: left; height: 42px">
            <el-col :xl="6" :lg="6" :md="6" :sm="6" :xs="24"><div class="grid-content">
              <el-form-item :label="$t('original.account')">
                <el-input  v-model="form.UserID"  :placeholder="$t('original.languages254')" ></el-input>
              </el-form-item></div></el-col>

            <el-col :xl="6" :lg="6" :md="6" :sm="6" :xs="24" style="margin-left: 20px;"><div class="grid-content">
                <el-form-item :label="$t('original.Name_of_Company')" prop="bumen">
                  <div class="block">
                    <el-cascader ref="wcascader" emitPath:false :show-all-levels="false" v-model="form.DepartID" :options="DepartDrop" :props="{ checkStrictly: true, emitPath: false }" clearable></el-cascader>
                  </div>
                </el-form-item></div></el-col>
            <el-col :xl="6" :lg="6" :md="6" :sm="6" :xs="24" style="margin-left: 20px;"><div class="grid-content">
                <el-form-item :label="$t('original.languages190')">
                  <el-select v-model="form.CancelApproval" :placeholder="$t('original.languages3')">
                    <el-option label="全部" value="0"></el-option>
                    <el-option label="待审批" value="1"></el-option>
                    <el-option label="已同意" value="2"></el-option>
                    <el-option label="已拒绝" value="3"></el-option>
                  </el-select>
                </el-form-item></div></el-col>
          </el-row>
          <el-row style="float: right; height: 42px">
            <el-col :xl="24" style="text-align: right">

              <el-button type="primary" @click="aaa1()"> {{ $t('original.screening') }}</el-button>

              <el-button type="primary" @click="clearFrom()"> {{ $t('original.reset') }}</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-header>
      <el-main style="margin-top: 15px; background: rgba(255, 255, 255, 1)">

        <el-row>
          <el-col :xl="24" style="margin-bottom: 20px">
            <el-button type="primary" :loading="loadingstart" @click="getVsitorNameList()">{{ $t('original.languages271') }} </el-button>
          </el-col>
          <el-table ref="multipleTable" v-loading="load" :element-loading-text="$t('original.languages22')"  element-loading-spinner="el-icon-loading" :data="tableData" tooltip-effect="dark" style="width: 100%">
            <el-table-column :label="$t('original.The_serial_number')" min-width="5%">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="UserID" :label="$t('original.account')" min-width="10%"></el-table-column>
            <el-table-column prop="RealName" :label="$t('original.name')" min-width="10%"></el-table-column>
            <el-table-column prop="Counselor" label="咨询师姓名" min-width="10%"></el-table-column>
            <el-table-column prop="Phone" label="学生联系方式" min-width="10%"></el-table-column>
            <el-table-column prop="Sex" :label="$t('original.gender')" min-width="6%"></el-table-column>
            <el-table-column prop="Age" :label="$t('original.languages256')" min-width="6%"></el-table-column>
            <el-table-column prop="DeptName" :label="$t('original.Name_of_Company')" min-width="20%"></el-table-column>
            <el-table-column prop="AppointmentTime" :label="$t('original.languages272')" min-width="15%"></el-table-column>
            <el-table-column prop="ConsultType" :label="$t('original.languages212')" min-width="8%"></el-table-column>
            <el-table-column prop="CancelApproval" :label="$t('original.languages214')" min-width="8%">
              <template slot-scope="scope">
                <span :class="scope.row.CancelApproval == 1 ? 'Statusblue' : scope.row.CancelApproval == 2 ? 'Statusgreen' : scope.row.CancelApproval == 4 ? 'Statusgray' : 'Statusred'">
                  {{ scope.row.CancelApproval == 1 ? $t('original.languages227') : scope.row.CancelApproval == 2 ? $t('original.languages203') : scope.row.CancelApproval == 4 ? $t('original.languages205') : $t('original.languages204') }}
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('original.languages49')" min-width="10%" align="center">
              <template slot-scope="scope">
                <span @click="dialoginfoVisible = true 
                SetAppointmentInfo(scope.row)" class="table_btn">
                   {{ $t('original.languages174') }}
                </span>
                <span v-if="scope.row.CancelApproval == 1" class="table_btn" @click="evocation(scope.row.AppointmentID)">
                   {{ $t('original.languages253') }}
                </span>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange3"
            :current-page.sync="form.pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Count"
            ></el-pagination>

        </el-row>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import add from '../Measurement/add.vue'
export default {
  components: { add },
  mounted() {
    this.getCancelReservation(this.form);
    if (sessionStorage.getItem('department')) {
      this.DepartDrop = JSON.parse(sessionStorage.getItem('department'));
    } else {
      this.$Http_Post('DepartMent/GetDeparMent', {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          sessionStorage.setItem('department', JSON.stringify(res.Data));
          this.DepartDrop = res.Data;
        }
      })
    }
  },
  data() {
    return {
      iscontinuous:false,
      Count:0,
      load: false,
      dialogTableVisible: false, //添加取消预约弹框
      addInformationShow: false, //控制添加申请附加信息显示
      dialoginfoVisible: false,
      loadingstart: false,
      VsitorNameList: [],
      tableData: [], //列表表格数据
      DepartDrop: [],
      form: {
        entity: sessionStorage.getItem('entity'),
        CancelApproval: '',
        UserID: '',
        DepartID: '',
        pageSize: '10',
        pageIndex: '1',
      },
      radios:'1',
      addInformation: {
        RealName: JSON.parse(localStorage.getItem('userInfo')).UserName,
        AppointmentID: '', //来访者姓名
        AppointmentTime: '', //预约时间
        ConAddressName: '', //咨询地点
        ConsultType: '', //咨询方式
        CancelCause: '', //取消原因
        ConsultCntIntroduce: '', //咨询问题描述
        ConsultTheme: '', //咨询主题
        UserName: '',
        // RealName: localStorage.getItem(JSON.parse(userInfo).UserName),
      },
      AppointmentInfo: {
        AppointmentID: '',
        AppointmentTime: '',
        CancelApproval: '',
        CancelCause: '',
        CancelPostil: '',
        ConsultCntIntroduce: '',
        ConsultTheme: '',
        ConsultType: '',
        DeptName: '',
        RealName: '',
        Sex: '',
        UserID: '',
        CancelTime: '',
        CancelUser: '',
      },
      evocationload:false,
    }
  },
  methods: {
    aaa1() {
      this.form.pageIndex = 1
      this.getCancelReservation(this.form);
    },
    handleCurrentChange3(val) {
      this.form.pageIndex = val;
      this.getCancelReservation(this.form);
    },

    getVsitorNameList() {
      this.loadingstart = true;
      this.$Http_Post('ConsultSubscribe/GetVsitorNameList', {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.loadingstart = false;
          this.VsitorNameList = res.Data;
          if (res.Data.length == 0) {
            this.$message(this.$t('original.languages273'));
          } else {
            this.dialogTableVisible = true;
          }
        }
      })
    },
    selectVsitorName() {
      for (let index = 0; index < this.VsitorNameList.length; index++) {
        if (this.VsitorNameList[index].AppointmentID == this.addInformation.AppointmentID) {
          this.addInformation.AppointmentTime = this.VsitorNameList[index].AppointmentTime;
          this.addInformation.ConAddressName = this.VsitorNameList[index].ConAddressName;
          this.addInformation.ConsultType = this.VsitorNameList[index].ConsultType;
          this.addInformation.CancelCause = this.VsitorNameList[index].CancelCause;
          this.addInformation.ConsultCntIntroduce = this.VsitorNameList[index].ConsultCntIntroduce;
          this.addInformation.ConsultTheme = this.VsitorNameList[index].ConsultTheme;
          this.addInformationShow = true;
        }
      }
    },
    clearAddInformation() {
      this.addInformationShow = false;
      this.addInformation.AppointmentTime = '';
      this.addInformation.ConAddressName = '';
      this.addInformation.ConsultType = '';
      this.addInformation.CancelCause = '';
      this.addInformation.ConsultCntIntroduce = '';
      this.addInformation.ConsultTheme = '';
      this.addInformation.AppointmentID = '';
    },
    CancelReservation(AppointmentID) {
      this.iscontinuous = true
      //申请取消预约
      this.$Http_Post('ConsultSubscribe/CancelReservation', {
        AppointmentID: this.addInformation.AppointmentID,
        CancelApproval: 1,
        CancelCause: this.addInformation.CancelCause,
        CancelSchedul: this.radios
      }).then((res) => {
        this.iscontinuous = false
        if (res.Code == 200 || res.Code == 0) {
          this.$message({
            message: this.$t('original.languages258'),
            type: 'success',
          })
          this.dialogTableVisible = false;
          this.getCancelReservation(this.form);
        }else{
          this.iscontinuous = false
        }
      })
    },

    getCancelReservation(from) {
      this.load = true;
      this.$Http_Post('ConsultSubscribe/GetCancelReservation', { from }).then(
        (res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.tableData = res.Data;
            this.Count = res.Counts;
            this.load = false;
          }
        }
      )
    },
    clearFrom() {
      this.form.CancelApproval = '';
      this.form.UserID = '';
      this.form.DepartID = '';
      this.form.pageIndex = 1
      this.getCancelReservation(this.form);
    },
    SetAppointmentInfo(row) {
      this.AppointmentInfo.AppointmentID = row.AppointmentID;
      this.AppointmentInfo.AppointmentTime = row.AppointmentTime;
      this.AppointmentInfo.CancelApproval = row.CancelApproval;
      this.AppointmentInfo.CancelCause = row.CancelCause;
      this.AppointmentInfo.CancelPostil = row.CancelPostil;
      this.AppointmentInfo.ConsultCntIntroduce = row.ConsultCntIntroduce;
      this.AppointmentInfo.ConsultTheme = row.ConsultTheme;
      this.AppointmentInfo.ConsultType = row.ConsultType;
      this.AppointmentInfo.DeptName = row.DeptName;
      this.AppointmentInfo.UserID = row.UserID;
      this.AppointmentInfo.RealName = row.RealName;
      this.AppointmentInfo.CancelUser = row.CancelUser;
      this.AppointmentInfo.CancelTime = row.CancelTime;
    },
    evocation(AppointmentID) {
      this.evocationload=true;
      this.$Http_Post('ConsultSubscribe/CancelReservation', {
        AppointmentID: AppointmentID,
        CancelCause: this.addInformation.CancelCause,
        CancelApproval: 4,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$message({
            message: this.$t('original.languages259'),
            type: 'success',
          })
          this.dialogTableVisible = false;
          for (let index = 0; index < this.tableData.length; index++) {
            if (AppointmentID == this.tableData[index].AppointmentID) {
              this.tableData[index].CancelApproval = 4;
            }
          }
        }
        this.evocationload=false;
      })
    },
  },
}
</script>

<style scoped>
.wp2CancelReservations td {
  line-height: 25px;
}

.wp2CancelReservations .td_left {
  color: rgba(141, 141, 141, 1);
  font-size: 14px;
  padding: 5px 15px;
}

.wp2CancelReservations .td_right {
  text-align: left;
  font-size: 14px;
  color: rgba(40, 40, 40, 1);
}

.el-dialog {
  height: auto !important;
}

.wp2CancelReservations .buttons {
  width: 100%;
  text-align: center;
  margin: 20px;
}

.wp2CancelReservations .Statusblue {
  border-radius: 4px;
  padding: 5px 10px;
  background: rgba(29, 154, 255, 0.1);
  color: rgba(29, 154, 255, 1);
}
.wp2CancelReservations .Statusgreen {
  border-radius: 4px;
  background-color: rgba(21, 191, 109, 0.1);
  color: rgba(21, 191, 109, 1);
  padding: 5px 10px;
}
.wp2CancelReservations .Statusred {
  border-radius: 4px;
  background-color: rgba(242, 75, 78, 0.1);
  color: rgba(242, 75, 78, 1);
  padding: 5px 10px;
}
.wp2CancelReservations .Statusgray {
  border-radius: 4px;
  padding: 5px 10px;
  background: rgba(141, 141, 141, 0.1);
  color: rgba(141, 141, 141, 1);
}
.wp2CancelReservations .el-form-item__label {
  text-align: right !important;
}
</style>
